import { createSlice } from '@reduxjs/toolkit';

import {
    FETCH_PROPOSAL_CONTENT,
    FETCH_PROPOSAL_CONTENT_FAILURE,
    FETCH_PROPOSAL_CONTENT_SUCCESS,
    RESET,
} from './actionTypes';
import { NAME } from './constants';

const INITIAL_STATE = {
    proposalContent: {
        data: {},
        errors: [],
        isFetching: false,
    },
};

const templateRenderSlice = createSlice({
    initialState: INITIAL_STATE,
    name: NAME,
    reducers: {
        [FETCH_PROPOSAL_CONTENT]: (state) => {
            state.proposalContent.isFetching = true;
        },
        [FETCH_PROPOSAL_CONTENT_FAILURE]: (state, action) => {
            state.proposalContent = {
                ...state.proposalContent,
                errors: action.payload,
                isFetching: false,
            };
        },
        [FETCH_PROPOSAL_CONTENT_SUCCESS]: (state, action) => {
            state.proposalContent = {
                ...state.proposalContent,
                data: action.payload,
                isFetching: false,
            };
        },
        [RESET]: () => INITIAL_STATE,
    },
});

export const templateRenderActions = templateRenderSlice.actions;

export default templateRenderSlice.reducer;
